import React from 'react'
import { useState } from "react";


export default function Contact() {
  const [name, setName] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    alert(`The name you entered was: ${name}`);
  }

  return (
    <div className='p-3'>
      <form onSubmit={handleSubmit} >
        <label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)} placeholder={"This is placeholder"}
          />
        </label>
        <input type="submit" />
      </form>
    </div>
  )
}

